



















import mixins from 'vue-typed-mixins';
import cloneDeep from 'lodash.clonedeep';
import RoleForm from '@/components/role/RoleForm.vue';
import RoleUtils, { Role } from '../../utils/RoleUtils';
export default mixins().extend({
  components: {
    RoleForm,
  },
  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },
  },
  data(): {
    pristine?: Partial<Role>;
    role?: Partial<Role>;
  } {
    return {
      pristine: undefined,
      role: undefined,
    };
  },
  async mounted() {
    this.$loading(true);
    try {
      if (this.id) {
        const resp = await Promise.all([RoleUtils.api.get(this.id)]);
        this.pristine = resp[0];
        this.role = cloneDeep(this.pristine);
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
    this.$loading(false);
  },
  methods: {
    async submit() {
      if (this.role) {
        try {
          this.$alert.hide('submit');
          await RoleUtils.api.update(this.role);
          this.pristine = cloneDeep(this.role);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.$languageobj('model.role.label')],
            }),
          });
        } catch (error) {
          this.$alert.show('submit', {
            type: 'error',
            messages: this.$handleAPIError(error, this.$refs.observer),
          });
        }
      }
    },
  },
});
